<template>
	<div>
		<!-- @click="$router.push('/betslip?type=' + type)" @click="canShowBottomSheet = true" -->
		<button class="nav__betslip" @click="$router.push('/betslip?type=' + type)">
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				v-if="betslipCount === 0"
			>
				<g clip-path="url(#clip0_308_3278)">
					<path
						d="M7.30469 9.17969C7.84403 9.17969 8.28125 8.74247 8.28125 8.20312C8.28125 7.66378 7.84403 7.22656 7.30469 7.22656C6.76535 7.22656 6.32812 7.66378 6.32812 8.20312C6.32812 8.74247 6.76535 9.17969 7.30469 9.17969Z"
						fill="black"
					/>
					<path
						d="M13.5946 20H6.40543C3.82117 20 1.71875 17.8976 1.71875 15.3133V4.68668C1.71875 2.10242 3.82117 0 6.40543 0H13.5945C16.1788 0 18.2812 2.10242 18.2812 4.68668V15.3133C18.2812 17.8976 16.1788 20 13.5946 20ZM6.40543 1.5625C4.68277 1.5625 3.28125 2.96402 3.28125 4.68668V15.3133C3.28125 17.036 4.68277 18.4375 6.40543 18.4375H13.5945C15.3172 18.4375 16.7188 17.036 16.7188 15.3133V4.68668C16.7188 2.96402 15.3172 1.5625 13.5946 1.5625H6.40543Z"
						fill="black"
					/>
					<path
						d="M14.3359 7.96875H13.0078C11.5001 7.96875 10.2734 6.74211 10.2734 5.23438V3.90625C10.2734 3.47477 10.6232 3.125 11.0547 3.125C11.4862 3.125 11.8359 3.47477 11.8359 3.90625V5.23438C11.8359 5.88055 12.3616 6.40625 13.0078 6.40625H14.3359C14.7674 6.40625 15.1172 6.75602 15.1172 7.1875C15.1172 7.61898 14.7674 7.96875 14.3359 7.96875Z"
						fill="black"
					/>
					<path
						d="M12.3828 15.4297H6.99219C6.5607 15.4297 6.21094 15.0799 6.21094 14.6484C6.21094 14.217 6.5607 13.8672 6.99219 13.8672H12.3828C12.8143 13.8672 13.1641 14.217 13.1641 14.6484C13.1641 15.0799 12.8143 15.4297 12.3828 15.4297Z"
						fill="black"
					/>
					<path
						d="M12.3828 12.4219H6.99219C6.5607 12.4219 6.21094 12.0721 6.21094 11.6406C6.21094 11.2091 6.5607 10.8594 6.99219 10.8594H12.3828C12.8143 10.8594 13.1641 11.2091 13.1641 11.6406C13.1641 12.0721 12.8143 12.4219 12.3828 12.4219Z"
						fill="black"
					/>
				</g>
			</svg>
			<span v-else>
				{{ betslipCount }}
			</span>
		</button>
	</div>
</template>

<script>
import Betslip from "../Betslip/MainBetslip.vue";
export default {
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	components: {
		Betslip,
	},
	computed: {
		type() {
			let type = "";
			const shikishaBaseRoute = window.SHIKISHA_PRODUCT_NAME.replace(
				/\s/,
				"-"
			).toLowerCase();
			if (this.$route.name == shikishaBaseRoute) type = "shikisha";
			if (this.$route.path.indexOf("virtual") > -1) type = "virtual";
			return type;
		},
		betslipCount() {
			let count = this.$store.getters.betSlipCount;
			const shikishaBaseRoute = window.SHIKISHA_PRODUCT_NAME.replace(
				/\s/,
				"-"
			).toLowerCase();
			if (this.$route.name == shikishaBaseRoute)
				count = this.$store.getters.jengabetBetSlipCount;
			if (this.$route.path.indexOf("virtual") > -1)
				count = this.$store.getters.virtualBetslipCount;
			if (this.$route.path.indexOf("turudi-uwanjani") > -1)
				count = this.$store.getters.boostedBetslipCount;
			return count;
		},
	},
	methods: {
		showBottomSheet() {
			let vm = this;
			// this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>
